import { NativeDateAdapter } from '@angular/material/core';
import moment from 'moment';
import { CustomValidators } from './custom-validators';

const formats = {
    de: 'DD.MM.YYYY'
};

export const APP_DATE_FORMATS = {
    parse: {
        dateInput: {month: 'short', year: 'numeric', day: 'numeric'}
    },
    display: {
        dateInput: 'input',
        monthYearLabel: {year: 'numeric', month: 'short'},
        dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
        monthYearA11yLabel: {year: 'numeric', month: 'short'},
    }
};

export class AppDateAdapter extends NativeDateAdapter {

    override parse(value: any): Date | null {
        const isValid = moment(value, ['D.M.YYYY', 'DD.MM.YYYY'], true).isValid();
        if (!isValid) {
            return null;
        }

        if ((typeof value === 'string') && (value.indexOf('.') > -1)) {
            value = CustomValidators.checkDateStringContent(value);
            const str = value.split('.');

            const date = new Date(parseInt(str[2], 10), parseInt(str[1], 10) - 1, parseInt(str[0], 10));
            const year = parseInt(new Intl.DateTimeFormat('de', { year: 'numeric' }).format(date), 10);
            const month = parseInt(new Intl.DateTimeFormat('de', { month: '2-digit' }).format(date), 10) - 1;
            const day = parseInt(new Intl.DateTimeFormat('de', { day: '2-digit' }).format(date), 10);

            return new Date(year, month, day);
        }
        const timestamp = typeof value === 'number' ? value : Date.parse(value);
        return isNaN(timestamp) ? null : new Date(timestamp);
    }

    override format(date: Date, displayFormat: Object): string {
        if (displayFormat === 'input') {
            return moment(date).format(formats.de);
        } else {
            return moment(date).format('LL');
        }
    }

}
